import React, {useState, useEffect} from 'react';
import {Row, Spinner, Button, Pagination} from 'react-bootstrap';

export const Pending=(props)=>{
	const [ pageCount, setPageCount ] = useState(0);
	const [ currentPage, setCurrentPage ] = useState(0);
	const [ pageArr, setPageArr ] = useState();
	const [ pageArrIndex, setPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (props.accounts!==undefined) {
			setPageArr(Object.keys(props.accounts));
			let len = Object.keys(props.accounts).length;
			setPageCount(Math.ceil(len/6));
		}
	},[props.accounts]);
	const next=(key)=>{		
		if (pageArrIndex+key<pageCount) {
			setPageArrIndex(prev=>(prev+key));
		}
	}
	const prev=(key)=>{
		if (pageArrIndex-key>=0) {
			setPageArrIndex(prev=>(prev-key));
		}
	}
	const [ spageCount, setsPageCount ] = useState(0);
	const [ currentsPage, setCurrentsPage ] = useState(0);
	const [ spageArr, setsPageArr ] = useState();
	const [ spageArrIndex, setsPageArrIndex ] = useState(0);
	useEffect(()=>{
		if (props.search!==undefined) {
			let len = Object.keys(props.search).length;
			setsPageArr(Object.keys(props.search));
			setsPageCount(Math.ceil(len/6));
		}
	},[props.search]);
	const snext=(key)=>{		
		if (spageArrIndex+key<spageCount) {
			setsPageArrIndex(prev=>(prev+key));
		}
	}
	const sprev=(key)=>{
		if (spageArrIndex-key>=0) {
			setsPageArrIndex(prev=>(prev-key));
		}
	}
	return(
		props.accounts!==undefined?(
			Object.keys(props.accounts).length>0?(
				props.search!==undefined&&Object.keys(props.search).length>0?(
						<Row className="mx-0" >
							{
								Object.keys(props.search).map((renew,r_i)=>(
									spageCount!==undefined&&r_i>=currentsPage&&r_i<currentsPage+6?(
									<div className="bdrb2 pending-item py-2 px-3" key={`account_${r_i}`} >
										<div>
											{
												props.search[renew].license_status?(
													<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
													):(
													<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
													)
											}
											<span className="tp1 f18 px-2" >{props.search[renew].account_name}</span><br />
											<span className="tp2 f14">Expiry Date : {props.search[renew].expiry_date},</span>
											<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
											{
								        		props.search[renew].days_remaining<=0?(
								        			<span className="expire-tag mx-2">Expired</span>
								        		):props.search[renew].days_remaining<30?(
								        			<span className="expire-tag mx-2">Expire in {props.search[renew].days_remaining} days.</span>
								        		):''
								        	}
										</div>
										<div className="d-grid" >
											{
												props.paRecLoad&&props.payid!==undefined&&props.payid===props.search[renew].renew_id?(
														<Button className="btn-t1-r self-center please-wait-spinner" Disable><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
															props.payRecive(props.search[renew].renew_id,props.search[renew].account_name);
														}} className="btn-t1-r self-center">Payment received</Button>
													)
											}
										</div>
										<div className="d-grid" >
										{
											props.search[renew].license_status?(
												props.disLoad&&props.did!==undefined&&props.did===renew?(
													<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
													props.disAcc(renew,props.search[renew].account_name);
													}} className="btn-disable self-center">Disable</Button>
												)
											):(
												props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
													<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
												):(
													<Button onClick={()=>{
														props.enable(renew,props.search[renew].account_name)
													}} className="btn-enable self-center">Enable</Button>
												)
											)
										}
										</div>
									</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setsPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{sprev(10)}} />
							      {
								      spageCount!==undefined&&spageArr!==undefined?(
										 spageArr.map((c,ci)=>(
										 	ci<spageCount?(
											 		ci>=spageArrIndex&&ci<spageArrIndex+10?(
												 		currentsPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentsPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{snext(10)}} />
							      <Pagination.Last onClick={()=>{setsPageArrIndex(Math.ceil(spageCount/10))}}  />
							    </Pagination>
						    </div>
						</Row>
					):(
						<Row className="mx-0" >
							{
								Object.keys(props.accounts).map((renew,r_i)=>(
									pageCount!==undefined&&r_i>=currentPage&&r_i<currentPage+6?(
										<div className="bdrb2 pending-item py-2 px-3" key={`account_${r_i}`} >
											<div>
												{
													props.accounts[renew].license_status?(
														<span className="sucess-tag" ><i className="bi bi-check-circle-fill"></i> Active </span>
														):(
														<span className="error-tag" ><i className="bi bi-exclamation-circle-fill"></i> Inactive </span>
														)
												}
												<span className="tp1 f18 px-2" >{props.accounts[renew].account_name}</span><br />
												<span className="tp2 f14">Expiry Date : {props.accounts[renew].expiry_date},</span>
												<span onClick={()=>{props.details(renew)}} className="f14 text-primary c-point"> Contact details</span>
												{
									        		props.accounts[renew].days_remaining<=0?(
									        			<span className="expire-tag mx-2">Expired</span>
									        		):props.accounts[renew].days_remaining<30?(
									        			<span className="expire-tag mx-2">Expire in {props.accounts[renew].days_remaining} days.</span>
									        		):''
									        	}
											</div>
											<div className="d-grid" >
											{
												props.paRecLoad&&props.payid!==undefined&&props.payid===props.accounts[renew].renew_id?(
														<Button className="btn-t1-r self-center please-wait-spinner" Disable><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
															props.payRecive(props.accounts[renew].renew_id,props.accounts[renew].account_name);
														}} className="btn-t1-r self-center">Payment received</Button>
													)
											}
											</div>
											<div className="d-grid" >
											{
												props.accounts[renew].license_status?(
													props.disLoad&&props.did!==undefined&&props.did===renew?(
														<Button className="btn-t1-r self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
														props.disAcc(renew,props.accounts[renew].account_name);
														}} className="btn-disable self-center">Disable</Button>
													)
												):(
													props.enableLoad&&props.enableId!==undefined&&props.enableId===renew?(
														<Button className="btn-enable self-center please-wait-spinner" disabled><Spinner animation="border" size="sm" /></Button>
													):(
														<Button onClick={()=>{
															props.enable(renew,props.accounts[renew].account_name)
														}} className="btn-enable self-center">Enable</Button>
													)
												)
											}
											</div>
										</div>
									):''
								))
							}
							<div className='pagination-wrap d-grid mt-3'>
								<Pagination>
							      <Pagination.First onClick={()=>{setPageArrIndex(0)}} />
							      <Pagination.Prev onClick={()=>{prev(10)}} />
							      {
								      pageCount!==undefined&&pageArr!==undefined?(
										 pageArr.map((c,ci)=>(
										 	ci<pageCount?(
											 		ci>=pageArrIndex&&ci<pageArrIndex+10?(
												 		currentPage===ci*6?(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} active>{ci+1}</Pagination.Item>
												 		):(
												 			<Pagination.Item key={`page_item_${ci}`} onClick={()=>{setCurrentPage(ci*6)}} >{ci+1}</Pagination.Item>
												 		)
												 	):''
										 		):''
										 	))
									   ):''
							      }
							      <Pagination.Next onClick={()=>{next(10)}} />
							      <Pagination.Last onClick={()=>{setPageArrIndex(Math.ceil(pageCount/10))}}  />
							    </Pagination>
						    </div>
						</Row>
					)
				):(<span className="tp3 p-3" >Nothing to renew.</span>)
			):(<span className="tp3 p-3" >Fetching data...</span>)
		)
}